import React, {useEffect} from 'react';
import {Button, Card, CardBody, Col, Container, Row} from "reactstrap";
import {useHistory} from "react-router-dom";
import step1 from "../../assets/img/icons/user/step-counting/step-1.png";
import step2 from "../../assets/img/icons/user/step-counting/step-2.png";
import step3 from "../../assets/img/icons/user/step-counting/step-3.png";
import step4 from "../../assets/img/icons/user/step-counting/step-4.png";

const SelectionListing = (props) => {
    const history = useHistory();

    useEffect(() => {

    }, [])
    const handleSubmit = () => {
        history.push("/easy-flow/step4/loading");
    }
    const previous = () => {
        history.goBack();
    }

    return (
        <div>
            <Container>
                <Card className="br-60 mt--150">
                    <CardBody className="p-5">
                        <Row>
                            <Col>
                                <div className="listing-header pt-1">
                                    <img src={step1} height={55} />
                                    <span className="text-white ml-2">Get Started</span>
                                </div>
                                <div className="mt-3">
                                    <div>
                                        <label className="listing-item">{props.userData.eventData?.assessmentName}</label>
                                    </div>
                                    <div>
                                        <label
                                            className="listing-item mt-2">{props.userData.eventData?.assessmentFor}</label>
                                    </div>
                                </div>
                            </Col>
                            <Col>
                                <div className="listing-header pt-1">
                                    <img src={step2} height={55} />
                                    <span className="text-white ml-2">Chosen Assessments</span>
                                </div>
                                <div className="mt-3">
                                    {props.userData.levels && Object.keys(props.userData.levels).map((ability) => (
                                        <div>
                                            <label className="list-item-heading">{ability} Assessments</label>
                                            <div>
                                                {props.userData.levels[ability].map((item) => (
                                                    <div>
                                                        <label className="listing-item">{ability === "competencies" ? item.name : item.secondName}</label>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </Col>
                            <Col>
                                <div className="listing-header pt-1">
                                    <img src={step3} height={55} />
                                    <span className="text-white ml-2">Customize</span>
                                </div>
                                <div className="mt-3">
                                    <div>
                                        <label className="list-item-heading">Registration Fields</label>
                                        <div>
                                            {props.userData.eventData?.registrationFields.map((field) => (
                                                <div>
                                                    <label className="listing-item">{field}</label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <div>
                                        <label className="list-item-heading">Log In Method</label>
                                        <div>
                                            {props.userData.eventData?.loginMethod.map((field) => (
                                                <div>
                                                    <label className="listing-item">{field}</label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <div>
                                        <label className="list-item-heading">Custom Artwork</label>
                                        <div>
                                            {props.userData.eventData?.customArtWork &&
                                                props.userData.step3?.customArtWork.map((field) => (
                                                    <label className="listing-item mr-2">{field}</label>
                                                ))}
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col>
                                <div className="listing-header pt-1">
                                    <img src={step4} height={55} />
                                    <span className="text-white ml-2">Configure & Launch</span>
                                </div>
                                <div className="mt-3">
                                    <label className="list-item-heading">Launch Date</label>
                                    <div>
                                        <label className="listing-item">{props.userData.eventData?.launchDate}</label>
                                    </div>
                                    <label className="list-item-heading">Closing Date</label>
                                    <div>
                                        <label className="listing-item">{props.userData.eventData?.closingDate}</label>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} xs={12} md={3} lg={3}>
                                <Button className="previous-button text-white w-100" onClick={previous}
                                    color="">Previous</Button>
                            </Col>
                            <Col sm={12} xs={12} md={6} lg={6}></Col>
                            <Col sm={12} xs={12} md={3} lg={3}>
                                <Button className="nextButton px-sm-0 border-0 text-white px-5 w-100"
                                    onClick={handleSubmit}
                                    color="">Next</Button>
                            </Col>
                        </Row>
                        {/*</Container>*/}
                    </CardBody>
                </Card>
            </Container>
        </div>
    );
};

export default SelectionListing;